import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatTableDataSource, MatDialogConfig, MatSnackBarConfig, MatSnackBar, MatDatepickerInputEvent} from '@angular/material';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';

import { SubjectProficiency } from '../shared/model/subject-proficiency.model';
import { Testing } from '../shared/model/testing.model';
import { SelectTestingDialogComponent } from 'src/app/core/modal/select-testing-dialog/select-testing-dialog.component';
import { RequestService } from '../shared/request.service';
import { TypeTesting } from '../shared/model/TypeTesting';
import { FormControl } from '@angular/forms';
import { SnackbarMessageComponent } from 'src/app/core/snackbar-message/snackbar-message.component';
import { UploadfileDialogComponent } from '../../../core/modal/uploadfile-dialog/uploadfile-dialog.component';


@Component({
  selector: 'app-subjects-proficiency',
  templateUrl: './subjects-proficiency.component.html',
  styleUrls: ['./subjects-proficiency.component.scss'],

})
export class SubjectsProficiencyComponent implements OnInit {

  decimalPattern = '^[3-6]+([.][0-9]+)?$';
  // puntajePattern = '^(0?[' + '120' + '-' + '200' + ']|[1-9][0-9])$';
  displayedColumns = ['nombrePrueba', 'fechaPrueba', 'entidad', 'puntaje', 'archivoAdjunto', 'actionsColumn' ];
  dataSource;
  subjectsProficiency: SubjectProficiency[] = [];
  @Input() testing: Testing[] = [];
  @Input() cedula: String;
  typeTesting: TypeTesting[];
  date = new Date();
  @Output() setMessage: EventEmitter<any> = new EventEmitter();
  procent: String[] = [];

  constructor(private dialog: MatDialog, private requestService: RequestService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.insertSubjectT();
    this.setMessage.emit('');
  }
  onSearchChange(value) {
    console.log(value);
  }

  clean() {
    this.subjectsProficiency = [];
    this.insertSubjectT();
  }

  deleteSubjectT(item) {
    this.subjectsProficiency.splice(item, 1);
    this.dataSource = new MatTableDataSource(this.subjectsProficiency);
  }

  insertSubjectT() {
    this.setMessage.emit('');
    const subject = new SubjectProficiency();
    this.subjectsProficiency.push(subject);
    this.dataSource = new MatTableDataSource(this.subjectsProficiency);
  }

  openDialog(subject) {
    this.setMessage.emit('');
    const index =  this.dataSource.filteredData.indexOf(subject);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { testing: this.testing, index: index};
    dialogConfig.width = '50%';
    let puntaje: any;
    const dialogRef = this.dialog.open(SelectTestingDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value !== null) {
          if (value.test !== undefined) {
          if (this.validateSubjectsTesting(value.test.idprueba)) {
            if (value.test.tipovalidacionpuntaje !== 'RangoNumerico' && value.test.tipovalidacionpuntaje !== 'Porcentaje') {
              this.getTypeTesting(value.test.tipovalidacionpuntaje);
              puntaje = value.test.puntajeminimo;
            } else if (value.test.tipovalidacionpuntaje === 'Porcentaje') {
              this.getTypeTestingPorc(value.test.puntajeminimo, value.test.maxRango);
              puntaje = value.test.puntajeminimo;
            } else if (value.test.puntajeminimo.search(',') === 1) {
              this.subjectsProficiency[value.index].isDecimal = true;
               puntaje = value.test.puntajeminimo.replace(',', '.');
            } else  {
              this.subjectsProficiency[value.index].isDecimal = false;
              puntaje = value.test.puntajeminimo;
              // (1[4-6][0-9]|170)'

              this.subjectsProficiency[value.index].puntajePattern = '^([' + value.test.puntajeminimo + '-' + value.test.maxRango +
            '])*$';
              // console.log(this.subjectsProficiency[value.index].puntajePattern);
            }
            this.subjectsProficiency[value.index].idPrueba = value.test.idprueba;
            this.subjectsProficiency[value.index].nombrePrueba = value.test.nombre;
            this.subjectsProficiency[value.index].puntaje = puntaje;
            this.subjectsProficiency[value.index].tipoPuntaje = value.test.tipovalidacionpuntaje;
            this.subjectsProficiency[value.index].maxRango = value.test.maxRango;
            this.subjectsProficiency[value.index].minRango = puntaje;
            this.subjectsProficiency[value.index].vigencia = value.test.vigencia;
            let message = value.test.explicacionpuntaje;
            this.openSnackBar(message, value.index);
            if (value.test.textoAyuda !== undefined) {
              message = message + '<br> ' + value.test.textoAyuda;
              this.openSnackBar(message, value.index);
            }

          } else {
            const message = 'La prueba ' + value.test.nombre + ' ya fue seleccionada';
            this.setMessage.emit(message);
          }
        }
      }
    });
  }

  openFileDielog(element: SubjectProficiency) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  {cedula: this.cedula, codigo: element.idPrueba};
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(UploadfileDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      value => {
        if (value !== null) {
            element.archivoAdjunto = value.fileName;
            element.pathArchivo = value.path;
        }
      }
    );
  }

  deleteFile(element) {
    element.archivoAdjunto = undefined;
  }


  onFecha() {
    console.log('Si cambio');
  }


  private validateSubjectsTesting(value): boolean {
    let result = true;
    this.subjectsProficiency.forEach(element => {
      if (element.idPrueba === value) {
        result = false;
      }
    });
    return result;
  }

  private getTypeTesting(typeTesting) {
    this.requestService.getTypeTesting(typeTesting).subscribe(
      (result) => {
        if (result.data !== {}) {
          this.typeTesting = result.data as TypeTesting[];
        }
      }
    );
  }

  private getTypeTestingPorc(min , max) {
    for (let i = min; i <= max; i++) {
      this.procent.push(i);
    }
  }

  openSnackBar(message, index) {
    const snackBarConfig = new MatSnackBarConfig();
    snackBarConfig.data =  { message: message };
    snackBarConfig.duration = 20500;
    const dd = this.snackBar.openFromComponent(SnackbarMessageComponent, snackBarConfig);
    dd.afterDismissed().subscribe(
      (result) => {
        this.dataSource =  new MatTableDataSource(this.subjectsProficiency);

      }
    );
  }
}
